module.exports = __webpack_public_path__ + "src/assets/games/47/5.png";